import { XIcon } from '@_shared/icons';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';
import { InformationPopup } from '@_shared/ui/Popup';
import { Typography } from '@_shared/ui/Typography';

import * as S from './ContentBucketFailPopup.style';

export function ContentBucketFailPopup() {
	const { popLayer } = useUILayerStore();
	return (
		<InformationPopup.Container closePopup={popLayer}>
			<S.CloseButton onClick={popLayer}>
				<XIcon />
			</S.CloseButton>
			<InformationPopup.TextContainer>
				<InformationPopup.Title>콘텐츠를 다시 공유해주세요!</InformationPopup.Title>
				<InformationPopup.SubText>
					요청을 처리하는데 문제가 생겼어요.
					<br />
					이전 화면으로 돌아가
					<br />
					다시 공유하면 정상적으로 처리됩니다.
				</InformationPopup.SubText>
				<Typography type="body-medium" color="orange-primary" textAlign="center">
					서비스 이용에 불편을 드려 죄송합니다.
				</Typography>
			</InformationPopup.TextContainer>
		</InformationPopup.Container>
	);
}
